<template>
  <section class="bonus-campaign-goal-reminder">
    <div class="bonus-campaign-goal-reminder__header">
      <span class="bonus-campaign-goal-reminder__badge" aria-hidden="true">
        <img v-if="iconSrc" :src="iconSrc" alt="" />
        <i v-else class="fas fa-chart-line"></i>
      </span>
      <h3 class="bonus-campaign-goal-reminder__eyebrow">
        {{ $t(goalReminderEyebrowKey) }}
      </h3>
    </div>
    <div class="bonus-campaign-goal-reminder__middle">
      <p
        v-if="data.goalAchieved && data.beyondGoalTotalPointsLabelKey"
        class="bonus-campaign-goal-reminder__value bonus-campaign-goal-reminder__value--goal-achieved"
      >
        <span class="bonus-campaign-goal-reminder__value-num">{{
          $t(data.beyondGoalTotalPointsLabelKey)
        }}</span><span class="bonus-campaign-goal-reminder__value-unit">{{
          $t(beyondGoalTotalPointsUnitKey)
        }}</span>
      </p>
      <p v-else class="bonus-campaign-goal-reminder__value">
        <span class="bonus-campaign-goal-reminder__value-num">{{
          data.remainingUnits
        }}</span><span class="bonus-campaign-goal-reminder__value-unit">{{
          $t("portalHome.units.piecesCountUnit")
        }}</span>
      </p>
    </div>
    <p class="bonus-campaign-goal-reminder__days">
      <span class="bonus-campaign-goal-reminder__days-lead">{{
        $t(`${messagesPrefix}.goalReminderDaysLeftLead`)
      }}</span>
      <span class="bonus-campaign-goal-reminder__days-emphasis">{{
        $t(`${messagesPrefix}.goalReminderDaysLeftEmphasis`, {
          days: data.daysRemaining,
        })
      }}</span>
    </p>
  </section>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  messagesPrefix: { type: String, required: true },
  data: { type: Object, required: true },
  iconSrc: { type: String, default: null },
});

const beyondGoalTotalPointsUnitKey =
  "portalHome.bonusUhrd.beyondGoalTotalPointsUnit";

const goalReminderEyebrowKey = computed(() => {
  if (props.data?.firstMilestoneAchieved && !props.data?.goalAchieved) {
    return `${props.messagesPrefix}.goalReminderEyebrowRemaining`;
  }
  return `${props.messagesPrefix}.goalReminderEyebrow`;
});
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/bonus-campaign-goal-reminder-widget";
</style>
